import { DIALOG_ELEVATION_CLASS } from '../../components/ui/dialogElevation';

/**
 * Shared chrome for the share dialogs (SharePopover + EditShareGrantDialog)
 * so the two surfaces can't drift apart visually. The elevation (drop
 * shadow) itself is DIALOG_ELEVATION_CLASS, shared with any other dialog
 * that opts into the same Figma "Modal / Edit profile" treatment — only the
 * width here is share-dialog-specific.
 */
export const SHARE_DIALOG_CLASS = `sm:max-w-[420px] ${DIALOG_ELEVATION_CLASS}`;
